import React, { useState } from 'react';
import ComboboxAutocompleteAPI from './combobox_autocomplete_api';
import Fetching from './fetching';
import { getEmployeesWithActiveContract } from "../services/api_calendar";
import ListBoxQueryMultiSelectEmployeesActiveContract from './list_box_query_employee_active_contract';

export default function AlertForm({
  titleError,
  setTitleError,
  messageError,
  setMessageError,
  recipientError,
  selectedOption,
  selectedUnits,
  selectedEmployees,
  units,
  filter,
  searchQuery,
  isLoadingOu,
  handleOptionChange,
  handleUnitSelection,
  handleEmployeeSelection,
  handleCheckboxChange,
  handleCreateAlert,
  token,
  titleRef,
  messageRef,
  recipientRef,
}) {

  const getFilterValue = () => {
    if (filter === 'active') return 'contract_active';
    if (filter === 'inactive') return 'contract_not_active';
    if (filter === 'all') return 'all';
    return null;
  };

  return (
    <form onSubmit={handleCreateAlert}>
      <div className='border border-gray-200 rounded-md shadow-sm p-5'>
        <div ref={titleRef}>
          <label htmlFor="title" className="block text-sm font-medium leading-6 text-gray-900">
            Titolo
          </label>
          <div className="mt-2">
            <input
              type="text"
              name="title"
              id="title"
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-300 sm:text-sm sm:leading-6"
              placeholder="Titolo..."
              onChange={() => setTitleError(null)}
            />
            {titleError && <p className="text-red-500 text-xs mt-1">{titleError}</p>}
          </div>
        </div>
        <div ref={messageRef} className="mt-4">
          <label htmlFor="comment" className="block text-sm font-medium leading-6 text-gray-900">
            Messaggio
          </label>
          <div className="mt-2">
            <textarea
              rows={4}
              name="comment"
              id="comment"
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-300 sm:text-sm sm:leading-6"
              placeholder="Scrivi il tuo messaggio..."
              defaultValue={''}
              onChange={() => setMessageError(null)} 
            />
            {messageError && <p className="text-red-500 text-xs mt-1">{messageError}</p>}
          </div>
        </div>
        <div className="mt-4" ref={recipientRef}>
          <label className="block text-sm font-medium leading-6 text-gray-900">Invia a</label>
          <div className="mt-2 flex flex-col">
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={selectedOption === 'all'}
                onChange={() => handleOptionChange('all')}
                className="rounded text-indigo-600 focus:ring-indigo-600"
              />
              <label htmlFor="all" className="block text-sm font-medium ml-2 leading-6 text-gray-900">Tutti</label>
            </div>
            <div className="flex items-center mt-2">
              <input
                type="checkbox"
                checked={selectedOption === 'unit'}
                onChange={() => handleOptionChange('unit')}
                className="rounded text-indigo-600 focus:ring-indigo-600"
              />
              <label htmlFor="unit" className="block text-sm font-medium ml-2 leading-6 text-gray-900">Seleziona Unità Organizzative</label>
            </div>
            <div className="flex items-center mt-2">
              <input
                type="checkbox"
                checked={selectedOption === 'employee'}
                onChange={() => handleOptionChange('employee')}
                className="rounded text-indigo-600 focus:ring-indigo-600"
              />
              <label htmlFor="employee" className="block text-sm font-medium ml-2 leading-6 text-gray-900">Seleziona Dipendenti</label>
            </div>
            {recipientError && <p className="text-red-500 text-xs mt-1">{recipientError}</p>}
          </div>
        </div>

        {selectedOption === 'unit' && (
          <div className="mt-4 max-h-80 overflow-y-auto border rounded-lg shadow-md">
            <h3 className='block sticky top-0 text-sm font-bold leading-6 text-indigo-800 uppercase bg-indigo-200 p-3 rounded-t-lg'>
              Seleziona Unità Organizzative
            </h3>
            <div className='bg-white divide-y divide-gray-200'>
              {isLoadingOu ? (
                <Fetching />
              ) : (
                units
                  .slice()
                  .filter((unit) => !selectedUnits.some((selectedUnit) => selectedUnit.id === unit.id))
                  .map((unit) => (
                    <div key={unit.id} className="col-span-3 block text-sm font-medium leading-6 text-gray-600 cursor-pointer border-t">
                      <div
                        className="text-sm font-medium leading-6 text-gray-600 cursor-pointer hover:bg-indigo-50 p-2 px-4 justify-between items-center grid grid-cols-5"
                        onClick={() => handleUnitSelection(unit)}
                      >
                        <div className='col-span-3'>{unit.name}</div>
                        <div className='col-span-1 text-xs'>GESTORI: {unit.managers}</div>
                        <div className='col-span-1 text-xs'>DIPENDENTI: {unit.resources}</div>
                      </div>
                    </div>
                  )))}
            </div>
          </div>
        )}

        {selectedUnits.length > 0 && selectedOption === 'unit' && (
          <div className="border mt-6 rounded-lg shadow-md">
            <h3 className='block text-sm font-bold leading-6 text-indigo-800 uppercase bg-indigo-200 p-3 rounded-t-lg'>
              Destinatari: {selectedUnits.length} unità
            </h3>
            <div className='block text-xs font-medium ml-2 leading-6 text-gray-700 mb-2'>
              Puoi rimuovere le Unità dalla lista dei destinatari cliccando sul nome
            </div>
            <div className='max-h-80 overflow-y-auto'>
              {selectedUnits.map((unit) => (
                <button
                  key={unit.id}
                  className="block w-full text-left grid grid-cols-5 hover:bg-indigo-50"
                  onClick={() => handleUnitSelection(unit)}
                >
                  <div className='col-span-3 block text-sm font-medium leading-6 text-gray-600 cursor-pointer p-2 px-4 border-t'>
                    {unit.name}
                  </div>
                  <div className='col-span-1 block text-xs font-medium leading-6 text-gray-600 cursor-pointer p-2 border-t'>
                    GESTORI: {unit.managers}
                  </div>
                  <div className='col-span-1 block text-xs font-medium leading-6 text-gray-600 cursor-pointer p-2 border-t'>
                    DIPENDENTI: {unit.resources}
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        {selectedOption === 'employee' && (
          <div className='grid-cols-1 sm:grid grid-cols-3 gap-4 mt-2'>
            <div className="mt-4 col-span-1 border border-gray-200 rounded-lg shadow-md">
              <h3 className='block sticky top-0 text-sm z-10 font-bold leading-6 bg-indigo-200 text-indigo-800 uppercase p-3 rounded-t-md'>
                Seleziona Dipendenti
              </h3>
              <div className='z-10 px-3 pt-2'>
                <p className='block text-xs font-medium ml-2 leading-6 text-gray-900 uppercase tracking-wider'>
                  Visualizza:
                </p>
                <div className="flex flex-wrap items-center gap-4 mt-2">
                  <label className="flex items-center space-x-2 text-sm font-medium text-gray-900">
                    <input
                      type="checkbox"
                      value="active"
                      checked={filter === 'active'}
                      onChange={handleCheckboxChange}
                      className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <span>Contratti Attivi</span>
                  </label>
                  <label className="flex items-center space-x-2 text-sm font-medium text-gray-900">
                    <input
                      type="checkbox"
                      value="inactive"
                      checked={filter === 'inactive'}
                      onChange={handleCheckboxChange}
                      className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <span>Contratti Non Attivi</span>
                  </label>
                  <label className="flex items-center space-x-2 text-sm font-medium text-gray-900">
                    <input
                      type="checkbox"
                      value="all"
                      checked={filter === 'all'}
                      onChange={handleCheckboxChange}
                      className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <span>Tutti</span>
                  </label>
                </div>
                <div className='col-span-1 pt-4 pb-2 h-60'>
                  <ListBoxQueryMultiSelectEmployeesActiveContract
                    token={token}
                    selectedEmployees={selectedEmployees}
                    onChange={handleEmployeeSelection}
                    employeeRolePairs={selectedEmployees.map(e => ({ employeeId: e.id }))}
                    placeholder="Digita per cercare il dipendente"
                    wrapperClassName="h-60"
                    filterBy={getFilterValue()}
                    pageSize={10}
                  />
                </div>
              </div>
            </div>

            {selectedOption === 'employee' && (
              <div className="border col-span-1 sm:col-span-2 mt-4 rounded-lg shadow-md">
                <h3 className='block text-sm font-bold leading-6 text-indigo-800 uppercase bg-indigo-200 p-3 rounded-t-md'>
                  Destinatari: {selectedEmployees?.length} dipendenti
                </h3>
                <div className='block text-xs font-medium ml-2 leading-6 text-gray-700 mb-2'>
                  Puoi rimuovere i dipendenti dalla lista dei destinatari cliccando sul nome
                </div>
                <div className='max-h-80 overflow-y-auto'>
                  {selectedEmployees?.map((employee) => (
                    <button
                      key={employee.id}
                      className="block w-full text-left"
                      onClick={() => handleEmployeeSelection(employee)}
                    >
                      <div className='block text-sm font-medium leading-6 text-gray-600 cursor-pointer hover:bg-indigo-50 p-2 px-4 border-t'>
                        {employee.last_name && employee.first_name
                          ? `${employee.last_name} ${employee.first_name}`
                          : employee.cf}
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            )}

          </div>
 
        )}


        {selectedOption === 'all' ? (
          <div className="p-2 mt-2 font-semibold text-center text-sm text-gray-700">
            Il messaggio verrà inviato a tutti i dipendenti con contratto attivo
          </div>
        ) : selectedOption === 'unit'  && selectedUnits.length ? (
          <div className="p-2 mt-2 font-semibold text-center text-sm text-gray-700">
            Il messaggio verrà inviato ai dipendenti con contratto attivo che fanno parte dell'unità selezionata
          </div>
        ) : null}

        <div className="justify-center flex mt-5">
          <button
            type="submit"
            className="border block rounded-md px-3 py-2 mr-2 text-center text-sm font-semibold text-white bg-indigo-600 shadow-md hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-200"
          >
            Invia Messaggio
          </button>
        </div>
      </div>
    </form>
  );
}
